<template>
  <div id='hj-container'>
    <header-layout activeIndex="usinessPartner"></header-layout>
    <div class="companyDevelopment-bg2">
      <img src="../../assets/img/usinessPartner/usinessPartner_02.jpg" class="bg2-rowImg" width="100%" height="200px"/>
      <img src="../../assets/img/usinessPartner/usinessPartner_03_m.jpg" class="bg2-rowImg" width="100%"/>
      <img src="../../assets/img/usinessPartner/usinessPartner_04_m.jpg" class="bg2-rowImg" width="100%"/>
      <img src="../../assets/img/usinessPartner/usinessPartner_05_m.jpg" class="bg2-rowImg" width="100%"/>
      <img src="../../assets/img/usinessPartner/usinessPartner_07.jpg" class="bg2-rowImg mb40" width="100%"/>
    </div>
    <el-footer style='padding:0;'>
      <footer-layout></footer-layout>
    </el-footer>

  </div>
</template>

<script>
import HeaderLayout from '@/components/mobile/HeaderLayout.vue';
import FooterLayout from '@/components/mobile/FooterLayout.vue';

export default {
  name: "",
  components: {HeaderLayout, FooterLayout},
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
#hj-container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}

</style>
